import React from 'react';
import './TestsResult.scss'
import {Link} from 'react-router-dom'
const TestsStart = ({showsection}) => {
    return (
        <div className="tests-result">
        <div className="result-content">
            <h3 className="result-title title">Kirish testini boshlash</h3>
            <div className="result-info">
                <p>Berilgan vaqt vaqt: <span> 1 Soat</span> </p>
                <p>Savollar soni: <span>  32 ta </span></p>
                <p>O'tish bali : <span> 56 % va undan yurori</span></p>
            </div>
            <Link to='/categories/courses/modules/' className="button button-outline-primary">Bekor qilish</Link>
            <button className="button button-primary" onClick={showsection}>Boshlash</button>
        </div>
        
    </div>
    );
}

export default TestsStart;
